import React from 'react';
import { Icon } from "./index.js";
import IconTypeEnum from "Enum/IconTypeEnum";
import {useDataContext} from "UIDataHandler";

const NaOption = ({ onClick, isSelected }) => {
    const { controllerMode } = useDataContext();

    const [hover, setHover] = React.useState(false);

    return <div
        className={`
            flex flex-col items-center justify-evenly max-w-max h-[100px] mt-6 mx-auto p-3 mt-1 border-2 border-solid rounded-md text-center hover:cursor-pointer
         ${isSelected
            ? 'color1-bg color1-border color1-text choice-selected'
            : `${hover ? 'color3-bg color3-border color3-text choice-hover' : 'color2-bg color2-border color2-text choice-normal'}`}
         `}
        onClick={onClick}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
    >
        <>
            {controllerMode && <Icon type={IconTypeEnum.DOWN} size={25}/>}
            <div className={isSelected ? 'color1-text' : hover ? `color3-text` : 'color2-text'}>Not Applicable</div>
        </>
    </div>;
};

export default NaOption;
